'use client';

export default function GalleryHero() {
  return (
    <section className="relative bg-surface py-16 px-4 text-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-accent/5 pointer-events-none" />
      <div className="relative max-w-3xl mx-auto">
        <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent mb-4 px-3 py-1 bg-accent/10 rounded-full">
          Photo Gallery
        </span>
        <h1 className="text-4xl md:text-5xl font-bold text-text-primary mb-4 leading-tight">
          See Every Corner of Proximus
        </h1>
        <p className="text-lg text-text-secondary max-w-xl mx-auto">
          Browse through our curated collection of photos — from thoughtfully designed rooms to rooftop pools, dining spots, and more.
        </p>
      </div>
    </section>
  );
}
